import { UserService } from '../user/user.service';
import { LinkBuilder } from '../link-builder.service';
import { ResourceHelperService } from '../resource-helper.service';

/**
 * A dataservice that provides operations for rail settlement
 */
export class RailSettlementService {
  private rssSettlementBatchResource: InterACT.Interfaces.IResource<InterACT.Interfaces.RailSettlement.RssSettlementBatchResponse>;
  private rssSettlementBatchesResource: InterACT.Interfaces.IResource<InterACT.Interfaces.RailSettlement.RssSettlementBatchesResponse>;
  private rssSettlementRequestResource: InterACT.Interfaces.IResource<InterACT.Interfaces.RailSettlement.RssSettlementRequestsResponse>;

  constructor(
    private $resource: ng.resource.IResourceService,
    private userService: UserService,
    private linkBuilder: LinkBuilder,
    private resourceHelperService: ResourceHelperService
    ) {
    this.rssSettlementBatchResource = $resource('api/rss-settlement-batches/:rssSettlementBatchId');
    this.rssSettlementBatchesResource = $resource('api/rss-settlement-batches', 
    undefined,
    {
      save: {
        method: 'POST',
        headers: {
          'Access-Control-Expose-Headers': 'Location'
        },
        transformResponse: (data, headers) => {
          const response: any = {};
          response.data = data;
          (<any>response).headers = headers();
          return response;
        }
      }
    });
    this.rssSettlementRequestResource = $resource('api/rss-settlement-requests', 
    undefined,
    {
      save: {
        method: 'POST',
        headers: {
          'Access-Control-Expose-Headers': 'Location'
        },
        transformResponse: (data, headers) => {
          const response: any = {};
          response.data = data;
          (<any>response).headers = headers();
          return response;
        }
      }
    });
  }

  /**
 * Retrieves a single rss settlement batch using the supplied id
 * @param id the id of the rss settlement batch to retrieve
 * @return a promise that resolves with the rss settlement batch when the operation is complete
 */
  public get(id: string) {
    return this.rssSettlementBatchResource.get({ rssSettlementBatchId: id }).$promise;
  }

  /**
   * A method that gets a list of rss settlement batches using a given query.
   * 
   * @param page the number of records to retrieve
   * @param perPageCount the number of records to retrieve per page
   * @param query the query to use when querying the service
   */
  public getList(page: number, perPageCount: number, query: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.RailSettlement.RssSettlementBatchesResponse>>this.rssSettlementBatchesResource.get(options).$promise;
  }
  
  /**
   * Function to create a RSS Settlement Requests
   *
   * @param RssSettlementRequest An object representation of a rss settlement request
   * @returns A promise that resolves when the create operation is completed
   */
  public createRssSettlementRequest(RssSettlementRequest: InterACT.Interfaces.RailSettlement.RssSettlementRequest) {
    return this.rssSettlementRequestResource.save(RssSettlementRequest).$promise;
  }
  
  /**
   * A method that returns a new RssSettlementRequest object using the supplied arguments
   * @param startDateTime the start date time for the new rss settlement request
   * @param endDateTime the end date time for the new rss settlement request
   **/
  public getNewRssSettlementRequest( startDateTime: string, endDateTime: string): InterACT.Interfaces.RailSettlement.RssSettlementRequest {
    let schemeLink = this.linkBuilder.getSchemesLink(
      this.userService.selectedScheme.id
    );
    return {
      scheme: {
        abbreviation: (<any>this.userService.selectedScheme).abbreviation,
        link: schemeLink
      },
      startDateTime: startDateTime,
      endDateTime: endDateTime
    }
  }
}
